import { render, staticRenderFns } from "./DelAttrSpec.vue?vue&type=template&id=3f502649&scoped=true"
import script from "./DelAttrSpec.vue?vue&type=script&lang=js"
export * from "./DelAttrSpec.vue?vue&type=script&lang=js"
import style0 from "./DelAttrSpec.vue?vue&type=style&index=0&id=3f502649&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_29ccf6a1548590c1291b44f0faebdb79/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f502649",
  null
  
)

export default component.exports